export default theme => ({
  desc: {
    display: 'flex',
    gap: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    '& > *': {
      width: '100%',
      padding: theme.spacing(8, 4),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(4),
      },
      '& em': {
        color: theme.palette.blue.main,
        fontStyle: 'initial',
      },
    },
  },
  title: {
    padding: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  image: {
    width: '100%',
  },
  propositionsBlock: {
    backgroundColor: theme.palette.blue.main,
    padding: theme.spacing(8, 9),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 1),
      paddingRight: theme.spacing(4),
    },
    '& > *': {
      width: '100%',
      paddingLeft: theme.spacing(3),
      '& > *': {
        paddingBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          paddingBottom: 0,
        },
      },
    },
  },
  propositions: {
    display: 'flex',
    '& > *': {
      width: '100%',
    },
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
    },
  },
  proposition: {
    position: 'relative',
    color: theme.palette.secondary.main,
    paddingLeft: theme.spacing(4),
    paddingBottom: theme.spacing(2),
    // [theme.breakpoints.down('sm')]: {
    //   paddingLeft: 0,
    // },
    '&:before': {
      position: 'absolute',
      left: 0,
      color: theme.palette.secondary.color,
    },
  },
  prop1: {
    '&:before': {
      content: '"1 \\002014"',
    },
  },
  prop2: {
    '&:before': {
      content: '"2 \\002014"',
    },
  },
  prop3: {
    '&:before': {
      content: '"3 \\002014"',
    },
  },
  prop4: {
    '&:before': {
      content: '"4 \\002014"',
    },
  },
  prop5: {
    '&:before': {
      content: '"5 \\002014"',
    },
  },
  prop6: {
    '&:before': {
      content: '"6 \\002014"',
    },
  },
  propositionTitle: {
    color: theme.palette.blue.ultralight,
    paddingBottom: theme.spacing(4),
  },
});
